import { useRef } from 'react'
import { useCurrentUser } from '../../modules/context/UserContext'
import { isMulticampus } from '../../modules/utils'

const StackedBanner = ({ banners, count, totalBannerCount }) => {
  const { currentUser } = useCurrentUser()
  const ref = useRef(null)

  if (isMulticampus(currentUser)) return null

  if (totalBannerCount > 0 && count <= totalBannerCount)
    return (
      <div className="flex w-full flex-col">
        <div key={count} className="w-full" ref={ref}>
          {banners[count - 1]}
        </div>
        {totalBannerCount > 1 && count <= totalBannerCount && (
          <div className="relative h-[28px]">
            <div
              className="Body2-14Md absolute right-0 top-4 flex h-[24px] flex-row items-center gap-[4px] rounded-[40px] px-[8px] py-[2px]"
              style={{ backgroundColor: 'rgba(128,131,158,0.60' }}
            >
              <span className="text-white">{count}</span>
              <span className="text-white text-opacity-50">/</span>
              <span className="text-white text-opacity-50">{totalBannerCount}</span>
            </div>
          </div>
        )}
      </div>
    )
  else return null
}

export default StackedBanner
